import { AZURE } from './api';

const BASE = '/governance/clients';

export const listPlans = async () => {
  const { data } = await AZURE.get(`${BASE}/plans`);
  return data;
};

export const listModules = async () => {
  const { data } = await AZURE.get(`${BASE}/modules`);
  return data;
};

export const listSubscriptions = async () => {
  const { data } = await AZURE.get(`${BASE}/subscriptions`);
  return data;
};

export const getClientSubscription = async (institutionId) => {
  const { data } = await AZURE.get(`${BASE}/subscriptions/${institutionId}`);
  return data;
};

export const changeClientPlan = async (institutionId, planCode, reason = '') => {
  const { data } = await AZURE.post(`${BASE}/subscriptions/${institutionId}/change-plan`, {
    plan_code: planCode,
    changed_by: 'admin',
    reason
  });
  return data;
};

export const toggleClientModule = async (institutionId, moduleCode, enabled) => {
  const { data } = await AZURE.put(`${BASE}/subscriptions/${institutionId}/modules`, {
    module_code: moduleCode,
    enabled,
    granted_by: 'admin'
  });
  return data;
};
